import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.scss';
import '../node_modules/@mdi/font/css/materialdesignicons.min.css';
import '../node_modules/materialize-css/dist/css/materialize.min.css';
import '../node_modules/materialize-css/dist/js/materialize.min.js';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
